import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import HeaderWidgets from "layout/discovery/folder/categories/HeaderSearchText";
import DiscoverySearchBar from "layout/discovery/header/SearchBar";
import Dropdown, {
  dropdownTypes,
} from "@visiblethread/react-components/dist/components/Dropdown";
import ButtonsDropdownOption from "@visiblethread/react-components/dist/components/Dropdown/ButtonsDropdownOption";
import { buttonVariants } from "@visiblethread/react-components/dist/components/Button";
import { ReactComponent as FiltersIcon } from "icons/discovery/Filter.svg";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { applyFilter } from "slices/discovery/actions/filters";
import { FILTER_TYPES } from "constants/discovery";
import {fetchUniqueItemsCount} from "../../../../slices/discovery/actions/theme";

const HeaderText = ({ folderView }) => {
  const dispatch = useDispatch();

  const handleGapsRelativeToSingleDoc = () => {
    dispatch(showModal(modalTypes.SELECT_DOCUMENT));
  };

  const handleAlignmentAcrossDocs = () => {
    dispatch(applyFilter(FILTER_TYPES.ALIGNMENT_ACROSS_DOCS));
    dispatch(fetchUniqueItemsCount(FILTER_TYPES.ALIGNMENT_ACROSS_DOCS));
  };

  const handlePartialAlignmentAcrossDocs = () => {
    dispatch(applyFilter(FILTER_TYPES.PARTIAL_ALIGNMENT_ACROSS_DOCS));
    dispatch(fetchUniqueItemsCount(FILTER_TYPES.PARTIAL_ALIGNMENT_ACROSS_DOCS));
  };

  const handleUniqueReferenceAcrossDocs = () => {
    dispatch(applyFilter(FILTER_TYPES.UNIQUE_REFERENCES_ACROSS_DOCS));
    dispatch(fetchUniqueItemsCount(FILTER_TYPES.UNIQUE_REFERENCES_ACROSS_DOCS));
  };

  return (
    <div className="categories__header__title-container">
      <div className="categories__header__title-container__search_and_filters">
        <DiscoverySearchBar />
        {folderView && (
          <Dropdown
            type={dropdownTypes.buttons}
            propsObject={{
              button: <FiltersIcon />,
              options: [
                <ButtonsDropdownOption
                  key="1"
                  content="Gaps relative to a single doc"
                  onClick={handleGapsRelativeToSingleDoc}
                />,
                <ButtonsDropdownOption
                  key="2"
                  content="Full alignment across docs"
                  onClick={handleAlignmentAcrossDocs}
                />,
                <ButtonsDropdownOption
                  key="3"
                  content="Partial alignment across docs"
                  onClick={handlePartialAlignmentAcrossDocs}
                />,
                <ButtonsDropdownOption
                  key="4"
                  content="Unique references across docs"
                  onClick={handleUniqueReferenceAcrossDocs}
                />,
              ],
              hideArrowIcon: true,
              buttonVariant: buttonVariants.borderless,
            }}
          />
        )}
      </div>
      <HeaderWidgets />
    </div>
  );
};

HeaderText.propTypes = {
  folderView: PropTypes.bool.isRequired,
};

export default HeaderText;
